import React from 'react';
import { FileSpreadsheet, FileText, Download } from 'lucide-react';
export const ExportPanel = () => {
  const handleExport = format => {
    console.log(`Exporting to ${format}...`);
  };
  return <div className="flex gap-2" data-id="element-403">
      <button onClick={() => handleExport('excel')} className="inline-flex items-center px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors" data-id="element-404">
        <FileSpreadsheet className="h-5 w-5 mr-2" data-id="element-405" />
        Excel
      </button>
      <button onClick={() => handleExport('pdf')} className="inline-flex items-center px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors" data-id="element-406">
        <FileText className="h-5 w-5 mr-2" data-id="element-407" />
        PDF
      </button>
      <button onClick={() => handleExport('csv')} className="inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors" data-id="element-408">
        <Download className="h-5 w-5 mr-2" data-id="element-409" />
        CSV
      </button>
    </div>;
};